module.exports = __webpack_public_path__ + "static/img/member_icon_1.9e3087e5.png";